import React from "react";
import { supplierAccountingData } from "../../data/supplierAccountingData";
import ListItem from "../ListItem/ListItem";

const SupAccountant = () => {
  return <ListItem items={supplierAccountingData} />;
};

export default SupAccountant;
